//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import helper from "./helper"
import Table from "./Table.vue";
export default {
  name: "LatestUploads",
  components: {Table},
  props: {
    rules : {
      type: Object,
      required: true
    }
  },
  mounted: function () {
    BackendServices.getLatestUploads().then((response) => {
      this.originalData = response.data;
      let filtered = helper.splitTypes(response.data)
      this.salesFiles = filtered.sales
      this.stocksFiles = filtered.stocks
    });
    BackendServices.getDataBuilderStatus().then((response) => {
      this.dataBuilderData = response.data;
    });
    this.hasLoaded = true;

  },
  data: () => ({
    hasLoaded: true,
    latestUploadsTab: "sales",
    dataBuilderData: [],
    salesFiles: [],
    stocksFiles: [],
    levelOfServiceFiles: [],
    originalData: [],
  }),
  computed: {
    detailAble() {
      return this.rules.client_uploads;
    },
  },
};
